import { combineReducers, configureStore } from "@reduxjs/toolkit";
import activeTabSlice from "./activeTabSlice";
import showModal from "./showModalSlice";
import loginSlice from "./loginSlice";
import userDataSlice from "./userDataSlice";
import termsReducer from "./termsSlice";
import aboutAppReducer from "./aboutAppSlice";
import privacyPolicyReducer from "./privacyPolicySlice";
import feedbackReducer from "./feedbackSlice";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import localStorage from "redux-persist/es/storage";

// ✅ Only persist userDataSlice (whitelist approach)
const persistConfig = {
  key: "root",
  version: 1,
  storage: localStorage,
  whitelist: ["userDataSlice"],
};

const reducer = combineReducers({
  activeTab: activeTabSlice,
  showModal: showModal,
  loginSlice: loginSlice,
  userDataSlice: userDataSlice,
  terms: termsReducer,
  privacyPolicy: privacyPolicyReducer,
  aboutApp: aboutAppReducer,
  feedback: feedbackReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const configureAppStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default configureAppStore;
